import type { TithelyNavSettingsItem, TithelyNavSettingsSection } from '@/types/nav/tithelyNav'
import { useMe } from '@/queries/me'
import { useRoute } from 'vue-router'
import { filterNavPermissions } from '@/functions/nav'
import TRINITY_NAV_SETTINGS from '@/constants/nav/trinitySettings'

const useTithelyNavSettings = () => {
    const me = useMe()
    const { path } = useRoute()

    const filteredNav = (section: TithelyNavSettingsSection): TithelyNavSettingsItem[] => {
        if (path === `/r/suspended`) {
            return []
        }

        return filterNavPermissions(TRINITY_NAV_SETTINGS[section], me)
    }

    return {
        filteredNav
    }
}

export default useTithelyNavSettings
